import { ExpandedContent, Separator, EmptyState } from "../../Compartilhado/styles";
import { IItemHistoricoPlano } from "../../../../types";
import BlocoPrincipal from "../../Compartilhado/Blocos/BlocoPrincipal";
import { CampoValor } from "../../Compartilhado/Blocos/BlocoPrincipal";

interface ExpandedContentProps {
  item: IItemHistoricoPlano;
  isExpanded?: boolean;
}

function formatarValorMonetario(valor: any): string {
  if (valor === null || valor === undefined) return '—';
  if (typeof valor === 'number') {
    return `R$ ${valor.toFixed(2).replace('.', ',')}`;
  }
  return String(valor);
}

function mapearDadosNovoPrecoAdicionado(payload: any): CampoValor[] {
  if (!payload) return [];

  const campos: CampoValor[] = [];

  if (payload.area_direito) {
    campos.push({ campo: 'Área do Direito', valor: payload.area_direito });
  }
  if (payload.servico) {
    campos.push({ campo: 'Serviço', valor: payload.servico });
  }
  if (payload.tipo_audiencia) {
    campos.push({ campo: 'Tipo de Audiência', valor: payload.tipo_audiencia });
  }
  if (payload.modalidade) {
    campos.push({ campo: 'Modalidade', valor: payload.modalidade });
  }
  if (payload.profissional) {
    campos.push({ campo: 'Profissional', valor: payload.profissional });
  }
  if (payload.modo_precificacao) {
    campos.push({ campo: 'Modo de Precificação', valor: payload.modo_precificacao === 'sob_consulta' ? 'Sob Consulta' : 'Fixo em Créditos' });
  }
  if (payload.creditos_padrao != null) {
    campos.push({ campo: 'Créditos Padrão', valor: String(payload.creditos_padrao) });
  }
  if (payload.valor_credito != null) {
    campos.push({ campo: 'Valor/Crédito', valor: formatarValorMonetario(payload.valor_credito) });
  }
  
  // Calcular e exibir valor total (créditos * valor crédito) se ambos existirem e não for sob consulta
  if (payload.modo_precificacao !== 'sob_consulta' && 
      payload.creditos_padrao != null && 
      payload.valor_credito != null) {
    const valorTotal = Number(payload.creditos_padrao) * Number(payload.valor_credito);
    campos.push({ campo: 'Valor Total', valor: formatarValorMonetario(valorTotal) });
  }

  return campos;
}

export default function ExpandedContentNovoPrecoAdicionado({ item, isExpanded }: ExpandedContentProps) {
  const payload = typeof item.payload === 'string' ? JSON.parse(item.payload) : item.payload;
  const campos = mapearDadosNovoPrecoAdicionado(payload);

  if (campos.length === 0) {
    return (
      <ExpandedContent>
        <Separator />
        <EmptyState>Nenhum dado disponível.</EmptyState>
      </ExpandedContent>
    );
  }

  return (
    <ExpandedContent>
      <Separator />
      <BlocoPrincipal campos={campos} />
    </ExpandedContent>
  );
}
